import SpProductProfilesDialog from './SpProductProfilesDialog';

export default SpProductProfilesDialog;
